import Ajax from './Ajax.js'

const ForestTask = {
  getForestTasks: (id = null) => {
    let uri = id !== null
      ? '/forest-tasks' + '/' + id
      : '/forest-tasks'
    return Ajax.get(uri)
  },

  postForestTasks: (params) => {
    const payload = params && params.data ? params : {
      data: {
        area: params.area,
        taskType: params.taskType || params.task_type,
        scheduledDate: params.scheduledDate || params.scheduled_date,
        completedDate: params.completedDate || params.completed_date,
        status: params.status,
        evidenceFile: params.evidenceFile || params.evidence_file,
        notes: params.notes,
        verifiedBy: params.verifiedBy || params.verified_by,
        details: params.details
      }
    }
    return Ajax.post('/forest-tasks', payload)
  },

  putForestTasks: (params) => {
    const id = params.id
    const data = { ...params }
    delete data.id
    const payload = params && params.data ? params : { data }
    return Ajax.put('/forest-tasks/' + id, payload)
  },

  delForestTasks: (id) => {
    return Ajax.delete('/forest-tasks/' + id)
  }
}

export default ForestTask
